import React from 'react';
import './Sponsors.css';

const Sponsors = () => {
  return (
    <div id='sponsor' className="sponsors-section">
      <h2>Sponsors</h2>
      <p style={{ fontSize: '1.2rem', color: '#666' }}>Details to Come</p>
    </div>
  );
};

export default Sponsors;
